import { __rest } from "tslib";
import React from 'react';
import { compose } from 'redux';
import { Icon } from 'panamera-react-ui';
import StaticImageWithCTAAndDesc from "../StaticImageWithCTAAndDesc/StaticImageWithCTAAndDesc";
import PriceEstimation from "../PriceEstimation/PriceEstimation";
import BookAnAppointment from "../BookAnAppointment/R3/BookAnAppointment";
import StepProgress from "../StepProgress/StepProgress";
var css = {
  "splitViewWrapper": "oalp-2MQnw",
  "splitViewbackIcon": "oalp-1rSz8"
};
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import UserSession from "../../Utils/UserSession";
import useErrorCookie from "../../CustomHooks/useErrorCookie/useErrorCookie";
import { TRACKING_EVENTS } from "../../Constants/trackingEvents";
import { trackingHelper } from "../../Helpers/trackingHelper";
import { EVALUATION_STATES_TRACKING } from "../../Constants/evaluation";
var widgets = {
  StaticImageWithCTAAndDesc: StaticImageWithCTAAndDesc,
  StepProgress: StepProgress,
  BookAnAppointment: BookAnAppointment,
  PriceEstimation: PriceEstimation
};
export var SplitView = function SplitView(_a) {
  var name = _a.name,
    _a$data = _a.data,
    leftSection = _a$data.leftSection,
    rightSection = _a$data.rightSection,
    title = _a$data.title,
    logo = _a$data.logo,
    metadata = _a.metadata,
    handleIconClick = _a.handleIconClick,
    track = _a.track,
    locationId = _a.locationId,
    origin = _a.origin,
    landingURLSearch = _a.landingURLSearch,
    rest = __rest(_a, ["name", "data", "metadata", "handleIconClick", "track", "locationId", "origin", "landingURLSearch"]);
  var _ref = metadata || {},
    style = _ref.style,
    leftStyle = _ref.leftStyle,
    rightStyle = _ref.rightStyle,
    hideBackIcon = _ref.hideBackIcon,
    logoStyle = _ref.logoStyle;
  var widgetName = name;
  function renderComponent(widget, index) {
    var templateName = widget.templateName,
      data = widget.data,
      metadata = widget.metadata,
      sectionTitle = widget.sectionTitle,
      sectionSubTitle = widget.sectionSubTitle;
    var Component = widgets[templateName];
    return /*#__PURE__*/React.createElement("section", null, sectionTitle && /*#__PURE__*/React.createElement("h3", {
      style: sectionTitle.style
    }, sectionTitle.text), sectionSubTitle && /*#__PURE__*/React.createElement("p", {
      style: sectionSubTitle.style
    }, sectionSubTitle.text), /*#__PURE__*/React.createElement(Component, Object.assign({
      data: data,
      metadata: metadata,
      key: "".concat(templateName, "_").concat(index),
      handleIconClick: handleIconClick,
      track: track,
      locationId: locationId,
      origin: origin,
      landingURLSearch: landingURLSearch
    }, rest)));
  }
  function handleBackIconClick() {
    if (handleIconClick) {
      trackingHelper({
        eventName: TRACKING_EVENTS.VALUATION_EDIT_CAR_DETAILS_ERROR,
        track: track,
        locationId: locationId,
        origin: origin,
        select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE,
        landingURLSearch: landingURLSearch
      });
      handleIconClick(UserSession.getUserEvaluationState());
    }
  }
  useErrorCookie({
    widgetName: widgetName
  });
  return /*#__PURE__*/React.createElement("div", {
    "data-aut-id": "splitViewWrapper",
    className: css.splitViewWrapper
  }, /*#__PURE__*/React.createElement("div", {
    style: title === null || title === void 0 ? void 0 : title.style
  }, !hideBackIcon && /*#__PURE__*/React.createElement("span", {
    onClick: handleBackIconClick,
    "data-aut-id": "splitViewbackIcon",
    className: css.splitViewbackIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "arrowLeft",
    color: "primary",
    size: "24"
  })), (logo === null || logo === void 0 ? void 0 : logo.image) && /*#__PURE__*/React.createElement("span", {
    style: logoStyle,
    "data-aut-id": "header-logo-image"
  }, /*#__PURE__*/React.createElement(ImageWrapper, {
    image: logo.image
  })), /*#__PURE__*/React.createElement("span", null, title === null || title === void 0 ? void 0 : title.text)), /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    style: leftStyle
  }, leftSection.map(function (widget, index) {
    return renderComponent(widget, index);
  })), /*#__PURE__*/React.createElement("div", {
    style: rightStyle
  }, rightSection.map(function (widget, index) {
    return renderComponent(widget, index);
  }))));
};
export default compose()(SplitView);